import { ProductMainGroups } from '../products-matrix/product-main-groups.enum';

export const CategoriesEnum = {
  ...ProductMainGroups,
  special_projects: 'special projects',
  new_arrivals: 'new arrivals',
} as const;

export type CategoriesEnum = (typeof CategoriesEnum)[keyof typeof CategoriesEnum];
